import { Award, ShieldCheck, BadgeCheck, Star, Building2 } from "lucide-react";
import { TRUST_BADGES } from "../lib/site";

const ICONS = { Award, ShieldCheck, BadgeCheck, Star, Building2 };

export default function TrustBadges() {
  const items = [...TRUST_BADGES, ...TRUST_BADGES]; // duplicate for marquee
  return (
    <div className="border-y border-white/5 bg-black/40 py-6 overflow-hidden" data-testid="trust-badges">
      <div className="marquee-track">
        {items.map((b, i) => {
          const Icon = ICONS[b.icon] || Award;
          return (
            <div key={i} className="flex items-center gap-4 whitespace-nowrap">
              <Icon size={20} className="text-[var(--gold)]" />
              <span className="text-sm uppercase tracking-[0.25em] text-white/80">{b.label}</span>
              <span className="text-[var(--gold)]/40">◆</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
